export const pastDueOptions = [
  {
    value: "Percentage",
    label: "Percentage"
  },
  {
    value: "Numbers",
    label: "Numbers"
  }
];

export enum CriteriaTypeOptions {
  AVERAGE = "Average",
  MINIMUM = "Minimum",
  MAXIMUM = "Maximum"
}

export const creditScoreTypeOptions = [
  {
    value: "Average",
    label: CriteriaTypeOptions.AVERAGE
  },
  {
    value: "Minimum",
    label: CriteriaTypeOptions.MINIMUM
  },
  {
    value: "Maximum",
    label: CriteriaTypeOptions.MAXIMUM
  }
];

export const recordsOptions = Array.from({ length: 11 }, (v, i) => ({
  value: i,
  label: String(i)
}));

export const yearsOptions = Array.from({ length: 10 }, (v, i) => ({
  value: i + 1,
  label: `within ${i + 1} year${i + 1 > 1 ? "s" : ""}`
}));

export const debounce = <T extends (...args: any[]) => any>(
  func: T,
  wait: number
): ((...args: Parameters<T>) => void) => {
  let timeout: ReturnType<typeof setTimeout> | null;
  return (...args) => {
    const later = () => {
      if (timeout) clearTimeout(timeout);
      func(...args);
    };
    if (timeout) clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};
